import React, { useState } from 'react';
import './FeaturedCourses.css';
import EnrollmentModal from './EnrollmentModal';

interface Course {
  id: number;
  title: string;
  bullets: string[];
  badges: { type: string; text: string }[];
  duration: string;
  students: number;
}

const courses: Course[] = [
  {
    id: 1,
    title: "Agentic AI Engineering",
    bullets: [
      "Multi-agent system architecture and design",
      "LangChain and agent orchestration frameworks",
      "Autonomous decision-making algorithms",
      "Agent communication and coordination",
      "Building production-ready AI agents"
    ],
    badges: [
      { type: "popular", text: "Popular" },
      { type: "level", text: "Advanced" },
      { type: "rating", text: "4.9" }
    ],
    duration: "12 weeks",
    students: 45
  },
  {
    id: 2,
    title: "Data Science with Python",
    bullets: [
      "Python programming for data analysis",
      "Statistical analysis and hypothesis testing",
      "Data visualization with Matplotlib & Seaborn",
      "Machine learning with Scikit-learn",
      "Real-world data science projects"
    ],
    badges: [
      { type: "popular", text: "Popular" },
      { type: "level", text: "Beginner" },
      { type: "rating", text: "4.8" }
    ],
    duration: "10 weeks",
    students: 89
  },
  {
    id: 3,
    title: "Prompt Engineering",
    bullets: [
      "Advanced prompt design techniques",
      "Chain-of-thought and few-shot prompting",
      "LLM optimization and fine-tuning",
      "Building AI-powered applications",
      "Prompt security and best practices"
    ],
    badges: [
      { type: "specialty", text: "AI" },
      { type: "level", text: "Intermediate" },
      { type: "rating", text: "4.7" }
    ],
    duration: "6 weeks",
    students: 67
  },
  {
    id: 4,
    title: "AIOps & MLOps Engineering",
    bullets: [
      "ML model deployment and monitoring",
      "CI/CD pipelines for machine learning",
      "Container orchestration with Kubernetes",
      "Model versioning and experiment tracking",
      "Production ML system optimization"
    ],
    badges: [
      { type: "specialty", text: "DevOps" },
      { type: "level", text: "Advanced" },
      { type: "rating", text: "4.9" }
    ],
    duration: "12 weeks",
    students: 38
  },
  {
    id: 5,
    title: "Data Engineering",
    bullets: [
      "Big data processing with Apache Spark",
      "Data pipeline design and automation",
      "Cloud data platforms (AWS, Azure, GCP)",
      "Real-time streaming with Kafka",
      "Data warehouse and ETL optimization"
    ],
    badges: [
      { type: "popular", text: "Popular" },
      { type: "level", text: "Intermediate" },
      { type: "rating", text: "4.8" }
    ],
    duration: "14 weeks",
    students: 52
  },
  {
    id: 6,
    title: "BI Analytics & Reporting",
    bullets: [
      "Business intelligence architecture design",
      "Data modeling and dimensional design",
      "Power BI and Tableau development",
      "SQL optimization and performance tuning",
      "Dashboard design and visualization"
    ],
    badges: [
      { type: "specialty", text: "Analytics" },
      { type: "level", text: "Intermediate" },
      { type: "rating", text: "4.6" }
    ],
    duration: "10 weeks",
    students: 34
  }
];

const FeaturedCourses: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState('');

  const handleEnrollClick = (courseName: string) => {
    setSelectedCourse(courseName);
    setModalOpen(true);
  };

  return (
    <section className="featured-courses" id="courses">
      <div className="container">
        <h2>Featured Courses</h2>
        <p className="section-intro">
          Explore our most popular programs in AI, Coding, Cloud, and Cybersecurity 
          to build in‑demand skills and accelerate your growth.
        </p>
        
        <div className="courses-grid">
          {courses.map((course) => (
            <div key={course.id} className="course-card">
              <div className="course-badges">
                {course.badges.map((badge, index) => (
                  <span key={index} className={`badge ${badge.type}`}>
                    {badge.text}
                  </span>
                ))}
              </div>
              <h3>{course.title}</h3>
              <ul className="course-bullets">
                {course.bullets.map((bullet, index) => (
                  <li key={index}>{bullet}</li>
                ))}
              </ul>
              <div className="course-meta">
                <span>{course.duration}</span>
                {course.students > 0 && <span>{course.students} students</span>}
              </div>
              <button 
                className="btn-primary"
                onClick={() => handleEnrollClick(course.title)}
              >
                Enroll Now
              </button>
            </div>
          ))}
        </div>
      </div>

      <EnrollmentModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        courseName={selectedCourse}
      />
    </section>
  );
};

export default FeaturedCourses;